import { Injectable } from '@angular/core';
import { interval } from 'rxjs';
import { filter, map, mergeMap, take, timeoutWith } from 'rxjs/operators';
import { IDVData } from '../models/data-model';
import { RegistrationApiService } from './registration-api.service';

@Injectable({
  providedIn: 'root'
})
export class IdvService {

    private currentIdvSessionData: IDVData;

    constructor(
        private readonly registrationApiService: RegistrationApiService
    ) { }

    setCurrentIdvSessionData(idvData: IDVData) {
        this.currentIdvSessionData = idvData;
    }

    getCurrentIdvSessionData(): IDVData {
        return this.currentIdvSessionData;
    }

    loadApplicationIDVData(applicantId: string): Promise<IDVData[]> {
        const POLLING_INTERVAL_MS = 2000;
        const POLLING_TIMEOUT_MS = 10000;

        return interval(POLLING_INTERVAL_MS).pipe(
            mergeMap(() => this.registrationApiService.getComplianceData(), 1),
            filter(complianceData => {
                const applicantIDVData = complianceData?.idvData?.find(data => data.contactId === applicantId);
                if (applicantIDVData) {
                    return Boolean(applicantIDVData.providerName) && Boolean(applicantIDVData.idvReference);
                } else {
                    return complianceData?.idvData?.some(data => data.providerName && data.idvReference);
                }
            }),
            take(1),
            timeoutWith(POLLING_TIMEOUT_MS, this.registrationApiService.getComplianceData()),
            map(complianceData => complianceData?.idvData)
        ).toPromise();
    }

    generateOnfidoSdkToken(idvReference: string): Promise<string> {
        return this.registrationApiService.getIdvToken(idvReference)
    }
}
